module.exports = __webpack_public_path__ + "static/media/login-bg.f57c295f.png";